import { PaperProps } from './types';

import { Wrapper } from './styled';

export default function Paper({ children }: PaperProps) {
  return <Wrapper>{children}</Wrapper>;
}
